export default {
  title: 'Aktiviere Benachrichtigungen für exklusive Angebote & Updates.',
  description: 'Erhalte Bestell-Updates in Echtzeit. Verfolge deinen Lieferstatus. Exklusive Angebote & Vorteile.',
  buttons: {
    confirm: 'Aktivieren',
    cancel: 'Nicht jetzt',
  },
};
